export default function HomeFiveTeam(){
    return(
        <section class="team-area pt-120 pt-md-60 pb-md-30 pt-xs-0 pb-xs-0 home-5">
			<div class="container">
				<div class="row justify-content-center">
					<div class=" col-lg-8">
						<div class="services-title2 text-center mb-55">
							<h6 class="semi-title semi-title2 pl-0">Team Members</h6>
							<h2 class="sect-title">Company Experts</h2>
						</div>
					</div>
				</div>
				<div class="row align-items-center">
					<div class="col-lg-3 col-md-6">
						<div class="team-wrapper mb-30">
							<div class="team-thumb2">
								<img src="assets/img/home-5/team-women-2-300x300.jpg" alt="Image" />
								<div class="team-icon-wrapper2">
									<div class="inner-team-icon pos-rel">
										<div class="team-icon">
											<a class="icon" href="#"><i class="fab fa-facebook-f"></i></a>
											<a class="icon" href="#"><i class="fab fa-twitter"></i></a>
											<a class="icon" href="#"><i class="fab fa-linkedin-in"></i></a>
										</div>
									</div>
								</div>
							</div>
							<div class="team-content text-center">
								<h6>Founder</h6>
								<h4 class="sub-title">Rosalina D. William</h4>
							</div>
						</div>
					</div>
					<div class="col-lg-3 col-md-6">
						<div class="team-wrapper mb-30">
							<div class="team-thumb2">
								<img src="assets/img/home-5/team-men-2-300x300.jpg" alt="Image" />
								<div class="team-icon-wrapper2">
									<div class="inner-team-icon pos-rel">
										<div class="team-icon">
											<a class="icon" href="#"><i class="fab fa-facebook-f"></i></a>
											<a class="icon" href="#"><i class="fab fa-twitter"></i></a>
											<a class="icon" href="#"><i class="fab fa-linkedin-in"></i></a>
										</div>
									</div>
								</div>
							</div>
							<div class="team-content text-center">
								<h6>CEO</h6>
								<h4 class="sub-title">Miranda H. Halim</h4>
							</div>
						</div>
					</div>
					<div class="col-lg-3 col-md-6">
						<div class="team-wrapper mb-30">
							<div class="team-thumb2">
								<img src="assets/img/home-5/team-women-1-300x300.jpg" alt="Image" />
								<div class="team-icon-wrapper2">
									<div class="inner-team-icon pos-rel">
										<div class="team-icon">
											<a class="icon" href="#"><i class="fab fa-facebook-f"></i></a>
											<a class="icon" href="#"><i class="fab fa-twitter"></i></a>
											<a class="icon" href="#"><i class="fab fa-linkedin-in"></i></a>
										</div>
									</div>
								</div>
							</div>
							<div class="team-content text-center">
								<h6>Designer</h6>
								<h4 class="sub-title">Alexis J. Jhalmuri</h4>
							</div>
						</div>
					</div>
					<div class="col-lg-3 col-md-6">
						<div class="team-wrapper mb-30">
							<div class="team-thumb2">
								<img src="assets/img/home-5/team-men-1-300x300.jpg" alt="Image" />
								<div class="team-icon-wrapper2">
									<div class="inner-team-icon pos-rel">
										<div class="team-icon">
											<a class="icon" href="#"><i class="fab fa-facebook-f"></i></a>
											<a class="icon" href="#"><i class="fab fa-twitter"></i></a>
											<a class="icon" href="#"><i class="fab fa-linkedin-in"></i></a>
										</div>
									</div>
								</div>
							</div>
							<div class="team-content text-center">
								<h6>Marketer</h6>
								<h4 class="sub-title">Piona L. Limonda</h4>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
    )
}